import styled, { device } from '@styled'

export const StyledText = styled.div`
  font-size: 18px;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
`
